import { render, staticRenderFns } from "./org_dialog.vue?vue&type=template&id=2b3ad17e&scoped=true"
import script from "./org_dialog.vue?vue&type=script&lang=js"
export * from "./org_dialog.vue?vue&type=script&lang=js"
import style0 from "./org_dialog.vue?vue&type=style&index=0&id=2b3ad17e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ad17e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3ad17e')) {
      api.createRecord('2b3ad17e', component.options)
    } else {
      api.reload('2b3ad17e', component.options)
    }
    module.hot.accept("./org_dialog.vue?vue&type=template&id=2b3ad17e&scoped=true", function () {
      api.rerender('2b3ad17e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/org_dialog.vue"
export default component.exports